import {Typography} from '@mui/material';
import { addHours, differenceInSeconds, parseISO} from 'date-fns';
import {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { getServerNow } from '../../../hooks/useServerTime';

export default ({datetime, mutate}) => {
    
    const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining(parseISO(datetime)));

    useEffect(() => {
        const intervalId = setInterval(() => {
            const newTimeRemaining = calculateTimeRemaining(parseISO(datetime));
            setTimeRemaining(newTimeRemaining);
            if (newTimeRemaining.total <= 0 || newTimeRemaining.total === 3600) {
                clearInterval(intervalId);
                mutate();
            }
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [datetime]);

    function calculateTimeRemaining(datetime) {
        const currentDate = getServerNow();
        const timeDifference = differenceInSeconds(addHours(datetime, 1),currentDate );

        if (timeDifference <= -2) {
            return {days: 0, hours: 0, minutes: 0, seconds: 0, total: 0};
        }

        const days = Math.floor(timeDifference / (60 * 60 * 24));
        const hours = Math.floor((timeDifference % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((timeDifference % (60 * 60)) / 60);
        const seconds = timeDifference % 60;

        return {days, hours, minutes, seconds, total: timeDifference};
    }

    return (
        <Typography sx={{color: '#fff'}}>
            {`${timeRemaining.hours} h, ${timeRemaining.minutes} min, ${timeRemaining.seconds} sec`}
        </Typography>
    );
};
